<script setup lang="ts">
import { ref, computed } from 'vue'
import { baseUrl, onChangedLanguage } from '@/core'
import { appBus } from '@/modules/app'
import AudioPlaylist from './base/AudioPlaylist.vue'

// State -----------------------------------------
const playlist = $config.backgroundMusicPlaylist.map((e) => (e = baseUrl(e)))
const autoplay = $config.backgroundMusicAutoplay
const audio = ref<InstanceType<typeof AudioPlaylist>>()

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
function onPlayed(event: any) {
  appBus.events.emit('backgroundMusic.played', { ...event })
  if (audio.value) {
    appBus.events.emit('backgroundMusic.info', audio.value.info())
  }
}

function onPaused(event: any) {
  appBus.events.emit('backgroundMusic.paused', { ...event })
}

// EventBus Commands -----------------------------
appBus.commands.on('backgroundMusic.play', (payload) => {
  audio.value?.play(payload?.replay)
})

appBus.commands.on('backgroundMusic.pause', (payload) => {
  audio.value?.pause()
})

appBus.commands.on('backgroundMusic.next', (payload) => {
  audio.value?.next(payload?.startPlay)
})

appBus.commands.on('backgroundMusic.select', (payload) => {
  audio.value?.select(payload?.track, payload?.startPlay)
})

appBus.commands.on('backgroundMusic.info', (payload) => {
  if (audio.value) {
    appBus.events.emit('backgroundMusic.info', audio.value.info())
  }
})

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <div class="background-music">
    <AudioPlaylist ref="audio" :playlist="playlist" :autoplay="autoplay" @played="onPlayed" @paused="onPaused" />
  </div>
</template>

<style scoped>
/* ------------------------ */
.background-music {
  position: absolute;
  display: inline-block;
  border: 1px solid;
  z-index: 1000;
}
/* ------------------------ */
</style>
@/@core
